import { TabStyles } from '@tableau/widgets';

export const copyLink: React.CSSProperties = {
	padding: `0 ${TabStyles.Spacing.SmallSpace}px`,
	height: 24,
};